const Form087EN = {
    stepName: {
        importantNotes: "Important Notes",
        information: "Information",
        confirmation: "Confirmation",
    },
    title: {
        applicantParticulars: "Uploading the Application Form",
        applicantParticulars2: "Submitting the Application",
        schoolInformation: "To be completed by School／Organisation",
        note: "Note",
        collectionStatement: "Personal Information Collection Statement",
    },
    label: {
        nameEn: "Name (English)",
        nameCn: "Name (Chinese)",
        email: "Email (For receiving emails about the captioned course)",
        HKAccount:
            "Hong Kong Education City Teacher Account Name (For logon to the course platform)",
        schoolOrOrganisationTel: "School／Organisation Telephone No.",
        select: "(Please Select)",
        schoolTelNo: "School Telephone No.",
        organisationTelNo: "Organisation Telephone No.",
        schoolOrOrganisationName: "Name of School／Organisation:",
        schoolName: "Name of School",
        organisationName: "Name of Organisation",
        reason: "Reason(s) for recommendation",
        schoolOrOrganisationChop: "Chop of School／Organisation:",
        schoolChop: "Chop of School",
        organisationChop: "Chop of Organisation",
        principalOrPersonName: "Name of Principal／Person in charge:",
        principalName: "Name of Principal",
        personName: "Name of Person in charge",
        principalOrPersonSignature: "Signature of Principal／Person in charge:",
        principalSignature: "Signature of Principal",
        personSignature: "Signature of Person in charge",
        date: "Date",
        applicationPeriod: "Application period:",
        courseDuration: "Course duration:",
        accountName: "account name",
        reasonMessage: "reason",
        noNameCn: "I do not have a Chinese name.",
        attachment:
            "Applicants should submit the completed form (both Part A and Part B completed) to the EDB by uploading the form here as an attachment.",
        courseIdEn: "English version (Course ID:{{cdiNumEn}})",
        courseIdCn: "Chinese version (Course ID:{{cdiNumTc}})",
        chooseVersion: "Please choose the language version of the course:",
        pdfExplanation:
            "Applicants should submit the completed form (both Part A and Part B completed) to the EDB by uploading the form here as an attachment.",
        pdfExplanation2:
            "If the application form is found incomplete, the EDB will return the form to the applicant. If so, the applicant has to delete the attachment here (please press the button of “Edit”) and re-upload a completed form for EDB’s consideration.",
    },
    note: {
        note1: {
            title: `1.	The personal data provided by you in this form will be used by the EDB for one or more of the following purposes: `,
            subtitle: "Purpose of Collection",
            content1:
                "Activities relating to the processing, authentication and counter-checking of application for the EDB Online Foundation Course for Teachers – Gifted Education;",
            content2:
                "Activities relating to <b>matching of the personal data</b> with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application  mentioned in (a) above; ",
            content3:
                "Activities relating to <b>matching of the personal data</b> within the database of EDB for purposes of verifying / updating records of the EDB;",
            content4:
                "Activities relating to <b>training and development</b> including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            content5:
                "Activities relating to the processing and vetting of applications for, and disbursement of, <b>funding / grants / subsidies</b>, and conducting of audits; ",
            content6:
                "Activities relating to compilation of <b>statistics, research</b> and <b>Government publications</b>; and",
            content7:
                "Activities relating to the <b>administration and enforcement of rules and regulations</b> including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant / Subsidised Schools Provident Fund Rules) and the Codes of Aid.",
        },
        note2: {
            title: `2.	The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.  `,
        },
        note3: {
            title: `3.	The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-`,
            subtitle: "Classes of Transferees",
            content1:
                "other Government bureaux and departments for the purposes mentioned in paragraph 1 above;",
            content2:
                "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            content3:
                "personnel, agent, service provider or organisations engaged by EDB to provide services or advice for purposes mentioned in paragraph 1 above;",
            content4:
                "where you have given your prescribed consent to such disclosure; and",
            content5:
                "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
        note4: {
            title: `4.	You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to the Executive Officer (Gifted Education) at Room E328, 3/F, East Block, Education Bureau Kowloon Tong Education Services Centre, 19 Suffolk Road, Kowloon Tong, Kowloon or at <a href="mailto:exoge@edb.gov.hk">exoge@edb.gov.hk</a>.`,
            subtitle: "Access to Personal Data",
        },
    },
    errorMsg: {
        alphabetsOnly: "Character type (alphabets only)",
    },
};
export default Form087EN;
